import { PropType, computed, defineComponent, ref, watch } from 'vue'
import { Store } from 'pinia'
import { useRoute } from 'vue-router'
import styles from './styles.module.scss'
import { ChargeMapContext } from '../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { Point } from '../../contract/map'
import debounce from 'lodash.debounce'

/**
 * 城市电区房渲染功能模块
 */
export default defineComponent({
  name: 'bubble-up-view',
  props: {
    mapInstance: {
      type: Object,
    },
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    BMapGL: {
      type: Object,
    },
  },

  setup: (props) => {
    // const mapContextRef = computed(() => props.mapContextRef)
    // const mapContextRef = ref<ChargeMapContext>()
    // const mapInstance = ref<any>()
    const mapInstance = computed(() => props.mapInstance)
    const BMapGL = computed(() => props.BMapGL)
    // const zoomLevel = ref<number>(0)
    const route = useRoute()
    // let BMapGL = null as any
    let infoWindowOverlay: any

    const showBubbleUp = () => {
      if (props.componentStore.bubbleDestLocation) {
        bubbleUpDebounce.cancel()
        closeBubbleUpWindow() // 保证只有一个气泡
        bubbleUpDebounce()
      }
    }

    const bubbleUpDebounce = debounce(
      () => {
        const loc = {
          lng: props.componentStore?.bubbleDestLocation?.lng,
          lat: props.componentStore?.bubbleDestLocation?.lat,
        } as Point
        if (props.componentStore.bubbleDestLocation?.name) {
          // 画气泡
          createBubbleUpWindow(createCustomOverlay(), loc)
        }
      },
      300,
      {}
    )

    const createCustomOverlay = () => {
      const wrapper = document.createElement('div')
      wrapper.className = styles.infoWrapper
      const elTitle = document.createElement('div')
      elTitle.className = styles.bubbleUpTitle
      elTitle.innerHTML = `<div>${props.componentStore.bubbleDestLocation?.name || ''}</div>`
      const elArrow = document.createElement('div')
      elArrow.className = styles.arrow
      wrapper.appendChild(elTitle)
      wrapper.appendChild(elArrow)
      return wrapper
    }

    const createBubbleUpWindow = (content: String | HTMLElement, loc: Point) => {
      // closeBubbleUpWindow() // 保证只有一个气泡
      infoWindowOverlay = new BMapGL.value!.CustomOverlay(() => content, {
        map: mapInstance,
        point: new BMapGL.value!.Point(loc.lng, loc.lat),
        offsetX: 0,
        offsetY: route.name == 'pin' ? -90 : -100,
      })
      mapInstance.value?.addOverlay(infoWindowOverlay)
    }

    const closeBubbleUpWindow = () => {
      infoWindowOverlay && mapInstance.value?.removeOverlay(infoWindowOverlay)
    }

    /**
     * 组件获取地图实例后的回调
     */
    // const onReady = () => {
    //   // mapInstance.value = mapContextRef.value?.getMap()
    //   // BMapGL = window.BMapGL
    //   // initEventListener()
    // }
    // watch(
    //   () => props.mapContextRef,
    //   () => {
    //     if (props.mapContextRef) {
    //       mapContextRef.value = props.mapContextRef
    //       onReady()
    //     }
    //   }
    // )
    watch(
      () => [
        props.componentStore.bubbleDestLocation?.lat,
        props.componentStore.bubbleDestLocation?.lng,
      ],
      () => {
        // 气泡统一由bubbleDestLocation控制
        if (props.componentStore.bubbleDestLocation) {
          showBubbleUp()
        } else {
          closeBubbleUpWindow()
        }
      }
    )
    return () => {}
  },
})
